<template>
  <v-form ref="form6">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Maaltijd</span>
      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary"
            >Hoeveel tussendoortjes wil je naast je ontbijt, lunch en
            diner?</span
          >
          <v-select
            v-model="
              localQuestions[
                'Hoeveel tussendoortjes wil je naast je ontbijt, lunch endiner?'
              ]
            "
            :rules="[rules.select_rules.required]"
            class="vragenlijst-v-select"
            :items="numbers"
            color="secondary"
            base-color="secondary"
            placeholder="Selecteer een optie"
            variant="underlined"
          >
            <template v-slot:append-inner>
              <v-icon class="v-select__menu-icon" color="secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M1 1L7 7L13 1"
                    stroke="#E26D6D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-icon>
            </template>
          </v-select>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Hoeveel variatie wil je in je plan?</span
          >
          <v-select
            :rules="[rules.select_rules.required]"
            v-model="localQuestions['Hoeveel variatie wil je in je plan?']"
            class="vragenlijst-v-select"
            :items="variations"
            color="secondary"
            base-color="secondary"
            placeholder="Selecteer een optie"
            variant="underlined"
          >
            <template v-slot:append-inner>
              <v-icon class="v-select__menu-icon" color="secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M1 1L7 7L13 1"
                    stroke="#E26D6D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-icon>
            </template>
          </v-select>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Heb je voedselallergieën of intoleranties?</span
          >
          <span class="text-extra-small">
            Zo ja, geef dan hieronder aan welke (bijvoorbeeld gluten, lactose,
            noten, etc.).
          </span>
          <v-text-field
            v-model="
              localQuestions['Heb je voedselallergieën of intoleranties?']
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Zijn er gerechten of ingrediënten die je niet lekker vindt of niet
            mag eten? Zo ja, welke?</span
          >
          <v-text-field
            v-model="
              localQuestions[
                'Zijn er gerechten of ingrediënten die je niet lekker vindt of niet mag eten? Zo ja, welke?'
              ]
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Zijn er specifieke dingen waarmee wij rekening moeten houden in
            jouw plan?</span
          >
          <span class="text-extra-small">
            Denk bijvoorbeeld aan zwangerschap, borstvoeding, een vegetarische
            of veganistische levensstijl, of andere persoonlijke voorkeuren of
            omstandigheden.
          </span>
          <v-text-field
            v-model="
              localQuestions[
                'Zijn er specifieke dingen waarmee wij rekening moeten houden in jouw plan?'
              ]
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Heb je een medische achtergrond?</span
          >
          <span class="text-extra-small">
            Als je medische aandoeningen hebt, zoals PCOS, een eetstoornis,
            hart- en vaatziekten, hoog cholesterol, nierproblemen, of iets
            anders, zou je daar meer over kunnen vertellen? Dit helpt ons om
            jouw plan optimaal af te stemmen.
          </span>
          <v-text-field
            v-model="localQuestions['Heb je een medische achtergrond?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Gebruik je medicatie of supplementen?</span
          >
          <v-text-field
            v-model="localQuestions['Gebruik je medicatie of supplementen?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Hoeveel tijd heb je om te koken of maaltijden voor te
            bereiden?</span
          >
          <v-text-field
            v-model="
              localQuestions[
                'Hoeveel tijd heb je om te koken of maaltijden voor te bereiden?'
              ]
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Heb je in het verleden een eetstoornis gehad of kamp je momenteel
            met een eetstoornis?</span
          >
          <v-select
            class="vragenlijst-v-select"
            :items="disorder_options"
            v-model="
              localQuestions[
                'Heb je in het verleden een eetstoornis gehad of kamp je momenteel met een eetstoornis?'
              ]
            "
            :rules="[rules.select_rules.required]"
            color="secondary"
            base-color="secondary"
            placeholder="Selecteer een optie"
            variant="underlined"
          >
            <template v-slot:append-inner>
              <v-icon class="v-select__menu-icon" color="secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M1 1L7 7L13 1"
                    stroke="#E26D6D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-icon>
            </template>
          </v-select>
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disorder_options: [
        "Nee",
        "Ik kamp momenteel met een eetstoornis",
        "Ik heb een eetstoornis gehad in het verleden",
      ],
      variations: ["Weinig", "Gemiddeld", "Veel"],
      numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      rules: FormRules.rules,
      localQuestions: { ...this.questions },
    };
  },
  methods: {
    nextStep() {
      this.$emit("nextStep", this.geslacht);
    },
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
